import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { getCookies } from "@utils";
import Axios from "@/Axios.js";
import { useConfirm, Loading } from "@components";
import { loginState } from "@pages/state";
import { interceptorState, defaultInterceptorState } from "./state";

function Interceptor({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const confirm = useConfirm();
  const [state, setState] = useAtom(interceptorState);
  const resetState = () => {
    setState({ ...defaultInterceptorState });
  };
  const [loginInfo, setLoginInfo] = useAtom(loginState);
  const personalPc = "personalPc";
  const cookies = getCookies();

  // 관리자 로그인 관리 프로세스
  // router를 통한 페이지 이동 전에 쿠키를 검증하여 자동 로그인 여부를 판단한다
  const loginProcess = (cookies) => {
    if ("hattomam_sess_id" in cookies) {
      return;
    } else {
      setLoginInfo((s) => ({ ...s, isLogin: false }));
    }

    if (personalPc in cookies) {
      const infos = cookies[personalPc].split("_");
      // 로그인
      Axios.post("/api/login", {
        id: infos[0],
        pw: infos[1],
      }).then((res) => {
        if (res.data?.errMsg) {
          confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
          return;
        }
        setLoginInfo((s) => ({ ...s, isLogin: true }));
      });
      return;
    }
  };

  // 권한 검증
  // 권한 검증이 필요한 URL의 권한을 검증한다
  const authenticate = (cookies) => {
    if (loginInfo.isLogin) {
      return;
    }
    if (personalPc in cookies) {
      return;
    }
    if (state.authUrls.includes(location.pathname)) {
      navigate("/");
    }
  };

  // url 변경에 따른 로그인 프로세스 진행
  useEffect(() => {
    loginProcess(cookies);
    // 페이지 이동시 스크롤 위치 조정
    // 컴포넌트 최상단으로 지정
    window.scrollTo(0, 0);

    return () => {
      resetState();
    };
  }, [location]);
  // 로그인 여부에 따른 관리자 URL 검증 진행
  useEffect(() => {
    authenticate(cookies);
  }, [loginInfo.isLogin]);

  return <Loading>{children}</Loading>;
}

export default Interceptor;
